export default __webpack_public_path__ + "files/8378dc8ec75612726c1902301d85f002.mp3";